import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'

export function CountryReadOnlyField ({ value, label, previousValue }) {
  const { t } = useTranslation()
  return (
    <ReadOnlyTextField
      value={value? t(`countries.${value}`): '-'}
      label={label}
      previousValue={previousValue && { value: previousValue.value? t(`countries.${previousValue.value}`): '-' }}
    />
  )
}
